export default {
  getMerchantInfoByTenantId: {
    method: 'get',
    url: '/v1/basic/tenant/merchant/get'
  }
}
